/* eslint-disable vars-on-top */
import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_SHIFTS } from '../actions';
import { getAllBookings } from '../api/DataHandlers';

const loadShiftsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_SHIFTS).mergeMap(action =>
        Observable.from(api.fetchShifts(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(action.payload, response))
            .catch(() =>
                Observable.of(actions.shiftsFailure('Problem loading shifts')),
            ),
    );

const toAction = (searchParams, response) => {
    if (response) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return actions.shiftsSuccess(flatShifts(searchParams, response.data));
    }
    return actions.shiftsFailure('Problem loading shifts');
};

export const flatShifts = (searchParams, data) => {

    if (!data || !data.content) {
        return undefined;
    }

    const results = [];
    const filterStatus = searchParams && searchParams.get('status');

    data.content.forEach(job => {
        let numberOfOpenPositions = job.number_of_freelancers;
        const bookings = getAllBookings(job);
        const validBookings = bookings.filter(b => b.status === 'OK').length;
        numberOfOpenPositions -= validBookings;

        if (bookings.length && filterStatus !== 'OP') {
            bookings.forEach(b => {
                if (job.status !== 'OP' || (job.status === 'OP' && b.status === 'OK')) {
                    results.push({
                        ...job,
                        booking: b,
                    });
                }
            });
            if (job.status === 'OP') {
                for (let i = 0; i < numberOfOpenPositions; i += 1) {
                    results.push(job);
                }
            }
        } else if (job.status === 'OP' && numberOfOpenPositions > 1) {
            for (let i = 0; i < numberOfOpenPositions; i += 1) {
                results.push(job);
            }
        } else {
            results.push(job);
        }
    });
    return {
        content: results,
        meta: data.meta,
    };
};

export default loadShiftsEpic;
